import { css } from 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import '../styled/index.js';
var Input = {
  base: css(["border-radius:0px;box-shadow:none;height:", "em;"], space(11)),
  Icon: {
    base: css(["height:", "em;"], space(11))
  }
};
export default Input;